export default __webpack_public_path__ + "static/media/3052.020822e9.jpg";